import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: () => import('@/views/Index'),
    redirect: { name: 'proyectos-dashboard' },
    children: [
      // Usuarios
      {
        path: '/usuarios/usuarios',
        name: 'usuarios',
        component: () => import('@/views/usuarios/Usuarios'),
      },
      //Perfiles
      {
        path: '/usuarios/perfiles',
        name: 'perfiles',
        component: () => import('@/views/usuarios/Perfiles'),
      },
      //Visitas
      {
        path: '/visitas',
        name: 'visitas',
        component: () => import('@/views/visitas/ReporteVisitas'),
      },    
      // Proyectos - Dashboard
      {
        path: '/proyectos/dashboard',
        name: 'proyectos-dashboard',
        component: () => import('@/views/dashboard/Dashboard'),
      },
      // Mapas
      {
        path: '/proyectos/mapas',
        name: 'Mapas de proyectos',
        component: () => import('@/views/mapas/mapa'),
      },
      // Proyectos - Prospectos
      {
        path: '/proyectos/prospeccion',
        name: 'proyectos-propeccion',
        component: () => import('@/views/prospeccion2'),
        redirect: { name: 'proyectos-prospeccion' },
        children: [
          {
            name: 'proyectos-prospeccion',
            path: 'prospeccion',
            component: () => import('@/views/prospeccion2/proyectos'),
          },
          {
            path: 'prospectar',
            component: () => import('@/views/prospeccion2/prospectar'),
          },
          {
            path: 'visitas',
            component: () => import('@/views/prospeccion2/visitas'),
          },
        ],
      },
      // Aprobación
      {
        name: 'Aprobación',
        path: '/proyectos/aprobacion',
        component: () => import('@/views/aprobacion'),
        redirect: { name: 'proyectos-aprobacion' },
        children: [
          {
            name: 'proyectos-aprobacion',
            path: 'aprobacion',
            component: () => import('@/views/aprobacion/proyectos'),
          },
        ],
      },
      // Negociación
      {
        name: 'Negociación',
        path: '/proyectos/negociacion',
        component: () => import('@/views/negociacion'),
        redirect: { name: 'proyectos-negociacion' },
        children: [
          {
            name: 'proyectos-negociacion',
            path: 'negociacion',
            component: () => import('@/views/negociacion/proyectos'),
          },
        ],
      },
      //Log global de comentarios
      {
        path: '/logGlobal',
        name: 'logGlobal',
        component: () => import('@/views/logGlobal/logGlobal'),
      },
      // Entidades Técnicas
      {
        name: 'Entidades Tecnicas',
        path: '/entidades/entidades',
        component: () => import('@/views/Entidades Tecnicas/EntidadesTecnicas.vue'),
      },
      {
        path: '/entidades/entidades/contactos',
        name: 'contactos de entidades tecnicas',
        component: () => import('@/views/Entidades Tecnicas/ContactosDeEntidadTecnica.vue'),
      },
      {
        path: '/entidades/entidades/direccion',
        name: 'verificacion direccion',
        component: () => import('@/views/Entidades Tecnicas/VerificarDireccion.vue'),
      },
      // Mapas
      {
        path: '/entidades/mapas',
        name: 'Mapas de entidades tecnicas',
        component: () => import('@/views/mapas/mapaEntidadesTecnicas.vue'),
      },
      // Convocatorias
      {
        path: '/entidades/convocatorias',
        name: 'Convocatorias',
        component: () => import('@/views/Convocatorias/Convocatorias.vue'),
      },
      // Contactos
      {
        path: '/contactos',
        name: 'Contactos',
        component: () => import('@/views/contactos/contacts.vue'),
      },
      // entidades de convocatorias
      {
        path: '/entidades/convocatorias/entidades',
        name: 'Entidades de una convocatoria',
        component: () => import('@/views/Convocatorias/EntidadesTecnicasDeConvocatoria.vue'),
      },
      {
        path: '/entidades/convocatorias/direccion',
        name: 'verificacion direccion de entidades de una convocatoria',
        component: () => import('@/views/Entidades Tecnicas/VerificarDireccion.vue'),
      },
      {
        path: '/entidades/convocatorias/contactos',
        name: 'Contactos de entidad',
        component: () => import('@/views/Entidades Tecnicas/ContactosDeEntidadTecnica.vue'),
      },
      // Comentarios
      {
        path: '/comentarios',
        name: 'comentarios',
        component: () => import('@/views/comentarios/Comentarios.vue'),
      },
      // Clientes
      {
        path: '/distribucion/clientes',
        name: 'clientes',
        component: () => import('@/views/Clientes/Prospeccion.vue'),
      },
      {
        path: '/distribucion/clientes/contact',
        name: 'contactos de cliente',
        component: () => import('@/views/Clientes/ContactosDeCliente.vue'),
      },
      {
        path: '/distribucion/clientes/ubicacion',
        name: 'ubicacion de cliente',
        component: () => import('@/views/Clientes/VerificarDireccion.vue'),
      },
      {
        path: '/distribucion/clientesActuales',
        name: 'clientes actual',
        component: () => import('@/views/ClientesActuales/ClientesActuales.vue'),
      },
      // Mapa de distribución
      {
        path: '/distribucion/mapa',
        name: 'distribuidores mapa',
        component: () => import('@/views/mapas/mapaCliente.vue'),
      },
      // Instaladores
      {
        path: '/instaladores',
        name: 'instaladores',
        component: () => import('@/views/Instaladores/ContactosDeInstaladores.vue'),
      },
    ],
  },
  // Otros paths principales
  {
    path: '/showFile',
    name: 'ver file',
    component: () => import('@/views/components/ShowFile.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login'),
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import('./views/NotFound'),
  },
]

const router = new Router({
  mode: 'history',
  routes,
})

router.beforeEach((to, from, next) => {
  const isAutheticated = firebase.auth().currentUser
  if (to.path !== '/login' && isAutheticated === null) {
    next({ name: 'Login' })
  } else {
    next()
  }
})

export default router
